import { type PropsWithChildren, useEffect, useState } from 'react';

import { isDefined, isNotDefined } from '@sgme/fp';

import { ServiceLoader } from './layout/components/ServiceLoader';
import { setupSgwtConnectWidget, type SgConnectUserInfo } from '@/helpers/auth';
import { createContext } from 'react';
import { bootstrapSignalRListeners, getSignalrConnection } from '@/helpers/signalr';
import { useAppDispatch } from '@/state/hooks';

const emptyUserInfo = {
  mail: '',
  name: '',
  sesame_id: '',
  origin_network: '',
} as const satisfies SgConnectUserInfo;

export const userInfoContext = createContext<SgConnectUserInfo>(emptyUserInfo);

export function UserInfoContextProvider({ children }: Readonly<PropsWithChildren>) {
  const [userInfo, setUserInfo] = useState<SgConnectUserInfo>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    setupSgwtConnectWidget({ onUserInfo: setUserInfo });
  }, []);

  useEffect(() => {
    if (isDefined(userInfo)) {
      bootstrapSignalRListeners(getSignalrConnection(), dispatch);
    }
  }, [userInfo, dispatch]);

  if (isNotDefined(userInfo)) {
    return <ServiceLoader />;
  }

  return <userInfoContext.Provider value={userInfo}>{children}</userInfoContext.Provider>;
}
